import { BatchModel } from './BatchModel';
import { JournalistBatchDto } from './JournalistBatchDto';

export interface JournalistBatchModel {
    classificationsId: number[],
    journalists: BatchModel[],
    journalistsDto: JournalistBatchDto[]
}

export const journalistBatchModelInitial: JournalistBatchModel = {
    classificationsId: [],
    journalists: [],
    journalistsDto: []
};